module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_306234.0780430e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_306234.pdf
// module id = 340
// module chunks = 0